<script setup>
import { CalendarGridBody } from "reka-ui";

const props = defineProps({
  asChild: { type: Boolean, required: false, default: undefined },
  as: { type: [String, Object, Function], required: false },
});
</script>

<template>
  <CalendarGridBody v-bind="props">
    <slot />
  </CalendarGridBody>
</template>
